module.exports = __webpack_public_path__ + "@/assets/img/banner-referido.04a8b0aa.gif";